<ng-container *ngIf="otherUsernameConnected">
  <div class="dialog-content other-username-connected">
    <div class="dialog-message-box">
      <div class="dialog-message-inner">
        <div class="dialog-message-text">
          <p class="dialog-message-line">
            <span>User </span>
            <span class="bold">{{ otherUsernameConnected }}</span>
            entered {{ pageName }}.<br />
            Time of entry:
            <span class="dialog-timestamp bold">{{
              currentTime | date: "dd/MM/yyyy HH:mm:ss z"
            }}</span
            >.
          </p>
        </div>
      </div>
    </div>

    <div class="dialog-info-text">
      <p class="bold">You have been disconnected.</p>
      <p>Only one user can control {{ pageName }} at a time.</p>
    </div>
  </div>
</ng-container>
